import { FC } from 'react';

export const JCBSvg: FC = () => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 200 120"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>large/jcb</title>
			<desc>Created with Sketch.</desc>
			<g id="Rounded" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="Large" transform="translate(-32.000000, -3380.000000)">
					<g id="large/jcb" transform="translate(32.000000, 3380.000000)">
						<rect id="Background" fill="#0A469C" x="0" y="0" width="200" height="120" rx="8" />
						<g
							id="Logo"
							transform="translate(44.000000, 16.000000)"
							fill="#FFFFFF"
							fillRule="nonzero"
						>
							<g id="jcb">
								<path
									d="M87.2973024,53.23307 L95.6565865,53.23307 C95.8954234,53.23307 96.4527092,53.1530115 96.6915461,53.1530115 C98.2837906,52.8327749 99.6371982,51.3917104 99.6371982,49.3902318 C99.6371982,47.4688127 98.2837906,46.0277482 96.6915461,45.6274526 C96.4527092,45.5473935 95.975036,45.5473935 95.6565865,45.5473935 L87.2973024,45.5473935 L87.2973024,53.23307 Z"
									id="Shape"
								/>
								<path
									d="M94.70124,0.153863856 C86.740017,0.153863856 80.2118133,6.6386538 80.2118133,14.7246264 L80.2118133,29.855803 L100.672157,29.855803 C101.149831,29.855803 101.707117,29.855803 102.105178,29.935862 C106.722687,30.1760396 110.146013,32.5778136 110.146013,36.7408884 C110.146013,40.023313 107.837259,42.8253829 103.538198,43.3857968 L103.538198,43.5459149 C108.23532,43.8661515 111.81787,46.5081028 111.81787,50.5911187 C111.81787,54.9943711 107.837259,57.8765005 102.582851,57.8765005 L80.1322012,57.8765005 L80.1322012,87.49838 L101.388667,87.49838 C109.349891,87.49838 115.878094,81.01359 115.878094,72.9276179 L115.878094,0.153863856 L94.70124,0.153863856 L94.70124,0.153863856 Z"
									id="Shape"
								/>
								<path
									d="M98.6022396,37.7015983 C98.6022396,35.7801789 97.2488315,34.4992327 95.6565865,34.2590554 C95.4973628,34.2590554 95.0993011,34.1789961 94.8604648,34.1789961 L87.2973024,34.1789961 L87.2973024,41.2242001 L94.8604648,41.2242001 C95.0993011,41.2242001 95.5769749,41.2242001 95.6565865,41.1441409 C97.2488315,40.9039635 98.6022396,39.6230174 98.6022396,37.7015983 L98.6022396,37.7015983 Z"
									id="Shape"
								/>
								<path
									d="M14.6113328,0.153863856 C6.65010941,0.153863856 0.121906232,6.6386538 0.121906232,14.7246264 L0.121906232,50.6711777 C4.18213014,52.6726563 8.40157855,53.9536022 12.621027,53.9536022 C17.6365977,53.9536022 20.3434138,50.9113553 20.3434138,46.7482804 L20.3434138,29.7757437 L32.7629222,29.7757437 L32.7629222,46.6682209 C32.7629222,53.23307 28.7026981,58.5970322 14.9297817,58.5970322 C6.57049718,58.5970322 0.042294007,56.7556721 0.042294007,56.7556721 L0.042294007,87.418321 L21.2987605,87.418321 C29.2599837,87.418321 35.788187,80.9335309 35.788187,72.8475583 L35.788187,0.153863856 L14.6113328,0.153863856 L14.6113328,0.153863856 Z"
									id="Shape"
								/>
								<path
									d="M54.6562868,0.153863856 C46.6950628,0.153863856 40.1668598,6.6386538 40.1668598,14.7246265 L40.1668598,33.7787005 C43.8290223,30.6563942 50.1980013,28.6549158 60.4679794,29.1352707 C65.9612235,29.3754481 71.8525287,30.8965716 71.8525287,30.8965716 L71.8525287,37.061125 C68.9068766,35.5400016 65.4039381,34.1789961 60.8660405,33.8587598 C53.0640418,33.2983458 48.3669199,37.1411843 48.3669199,43.8661515 C48.3669199,50.6711777 53.0640418,54.5140164 60.8660405,53.8735432 C65.4039381,53.5533066 68.9068766,52.1122421 71.8525287,50.6711777 L71.8525287,56.8357312 C71.8525287,56.8357312 66.0408361,58.3568552 60.4679794,58.5970322 C50.1980013,59.0773869 43.8290223,57.0759087 40.1668598,53.9536022 L40.1668598,87.5784391 L61.4233264,87.5784391 C69.3845498,87.5784391 75.9127526,81.093649 75.9127526,73.0076764 L75.9127526,0.153863856 L54.6562868,0.153863856 L54.6562868,0.153863856 Z"
									id="Shape"
								/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
};
